import { useEffect, useRef } from "react";
import styles from "./work.module.css";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import Text from "../text/text";
import Image, { ImageProps } from "../image/image";
import FutureWrap from "../future-wrap/future-wrap";
import FadeInTextEffect from "../fade-in-text-effect/fade-in-text-effect";
import { useMediaQuery } from "react-responsive";
import FadeInImageEffect from "../fade-in-image-effect/fade-in-image-effect";
import WatchGagsImage, {
  WatchGagsImageProps,
} from "../watch-gags-image/watch-gags-image";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export interface WorkPorps {
  index: number;
  containerAnimation?: gsap.core.Animation;
  category: string;
  header: string;
  photographys: Photography[];
  poster: Photography;
  common: string;
  author: {
    name: string;
    title: string;
    introduction: string;
  };
  worksLength: number;
}

export interface Photography extends WatchGagsImageProps {
  data?: string[];
  ratio?: number;
  preview?: string;
}
function Work(props: WorkPorps) {
  const box = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery({
    query: "(max-width: 1024px)",
  });
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (videoRef.current) {
        ScrollTrigger.matchMedia({
          "(min-width: 1024px)": function () {
            if (props.containerAnimation) {
              ScrollTrigger.create({
                containerAnimation: props.containerAnimation,
                trigger: videoRef.current,
                start: "left right",
                onEnter: () => {
                  console.log("尝试播放");
                  videoRef.current?.play();
                },
              });
            }
          },
          "(max-width: 1023px)": function () {
            ScrollTrigger.create({
              trigger: videoRef.current,
              start: "top bottom",
              onEnter: () => {
                console.log("尝试播放");
                videoRef.current?.play();
              },
            });
          },
        });
      }
    });

    return () => ctx.revert();
  }, [props.containerAnimation]);
  return (
    <div className={`${styles.ctn} shadow-v60-work-ctn`}>
      <div
        className={`${styles.title} shadow-v60-work-title`}
        onClick={() => {
          gsap.to(window, {
            scrollTo: props.containerAnimation?.parent?.scrollTrigger?.labelToScroll(
              `ctn-scroll-${props.index}`
            ),
          });
        }}
      >
        <Text figmaStyle="body-2">{`0${props.index + 1}`}</Text>
        <Text figmaStyle="body-1">{props.author.name}</Text>
        <Text figmaStyle="note">{props.category}</Text>
      </div>
      <div className={`${styles.content} shadow-v60-work-content`}>
        <div className={styles.box}>
          <div className={styles.header}>
            <FadeInTextEffect
              figmaStyle="header-1"
              containerAnimation={props.containerAnimation}
            >
              <Text figmaStyle="header-1">{props.header}</Text>
            </FadeInTextEffect>

            <FutureWrap
              chamfer="0"
              cornerHighlight="8"
              wrapClassName={styles.headerCategoryWrap}
              className={styles.headerCategory}
              fromToDeps={[props.containerAnimation]}
              admissionEffect={{
                animation: {
                  duration: 0.4,
                },
                scrollTrigger: !isMobile
                  ? {
                      containerAnimation: props.containerAnimation,
                      start: "left 80%",
                    }
                  : {
                      start: "top 80%",
                    },
              }}
            >
              <Text figmaStyle="header-2">{`${props.author.name} · ${props.category}`}</Text>
            </FutureWrap>
          </div>
          <FadeInImageEffect
            className={`${styles.photography} ${styles.poster}`}
            {...props.poster}
            containerAnimation={props.containerAnimation}
            style={
              {
                "--shadow-v60-image-ratio": props.poster.ratio ?? 1.5,
              } as React.CSSProperties
            }
          ></FadeInImageEffect>
        </div>

        <div className={`${styles.box} ${styles.photographys}`}>
          {props.photographys.map((item) => {
            return item.data ? (
              <div
                className={`${
                  styles.photographyWithDataBox
                } shadow-v60-photography-box ${
                  item.ratio !== undefined && item.ratio < 1
                    ? styles.smallScale
                    : ""
                }`}
              >
                {/* <div className={styles.data}>
                  {item.data.map((data) => (
                    <div>
                      <svg
                        width="16"
                        height="8"
                        viewBox="0 0 16 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 8L16 4L3.49691e-07 0L0 8Z" fill="white" />
                      </svg>
                      <Text figmaStyle="note">{data}</Text>
                    </div>
                  ))}
                </div> */}
                <WatchGagsImage
                  className={`${styles.photography} ${styles.photographyWithDataImage}`}
                  {...item}
                  containerAnimation={props.containerAnimation}
                  style={
                    {
                      "--shadow-v60-image-ratio": item.ratio ?? 1.5,
                    } as React.CSSProperties
                  }
                ></WatchGagsImage>

                <div className={`${styles.data} `}>
                  {item.data.map((data) => (
                    <div>
                      <svg
                        width="16"
                        height="8"
                        viewBox="0 0 16 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 8L16 4L3.49691e-07 0L0 8Z" fill="white" />
                      </svg>
                      <Text figmaStyle="note">{data}</Text>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <WatchGagsImage
                className={`${styles.photography} shadow-v60-photography-box`}
                {...item}
                containerAnimation={props.containerAnimation}
                data-ratio={props.poster.ratio}
                style={
                  {
                    "--shadow-v60-image-ratio": item.ratio ?? 1.5,
                  } as React.CSSProperties
                }
              ></WatchGagsImage>
            );
          })}
        </div>

        <div className={styles.box}>
          <div className={styles.introductionBox}>
            <FadeInTextEffect
              figmaStyle="header-1"
              containerAnimation={props.containerAnimation}
            >
              <Text figmaStyle="header-1" className={styles.introductionHeader}>
                {`{{摄影师}}{{{个人介绍}}}`}
              </Text>
            </FadeInTextEffect>

            <FutureWrap
              chamfer="0"
              cornerHighlight="16"
              wrapClassName={styles.introductionWrap}
              className={styles.introduction}
              fromToDeps={[props.containerAnimation]}
              admissionEffect={{
                animation: {
                  duration: 0.4,
                },
                scrollTrigger: !isMobile
                  ? {
                      containerAnimation: props.containerAnimation,
                      start: "left 60%",
                    }
                  : {
                      start: "top 80%",
                    },
              }}
            >
              <WatchGagsImage
                className={styles.authorImage}
                src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-author-${
                  props.index + 1
                }.jpg`}
              ></WatchGagsImage>

              <div className={styles.authorInfo}>
                <Text figmaStyle="header-3">{props.author.name}</Text>
                <Text figmaStyle="body-1">{props.author.title}</Text>
              </div>
              <Text className={styles.introductionContent} figmaStyle="body-2">
                {props.author.introduction}
              </Text>
            </FutureWrap>
          </div>
          <div
            className={styles.commonBox}
            style={{
              backgroundImage: `url(http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-comment-photo-${
                props.index + 1
              }.jpg)`,
            }}
          >
            <FadeInTextEffect
              figmaStyle="header-1"
              containerAnimation={props.containerAnimation}
            >
              <Text
                className={styles.commonHeader}
                figmaStyle="header-1"
              >{`{{智云五倍 V60}}{{{REAL 评}}}`}</Text>
            </FadeInTextEffect>

            <div className={styles.common}>
              <Image
                className={styles.commonGraphs}
                src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-comment-graphs.svg"
              ></Image>
              <div className={styles.commonContent}>
                <Text
                  figmaStyle="header-2"
                  className={styles.commonContentText}
                >
                  {props.common}
                </Text>

                <Text figmaStyle="header-3">{`{{—— ${props.author.name}}}`}</Text>
              </div>
            </div>
          </div>

          {props.index === props.worksLength - 1 ? (
            <div className={styles.toProductBox}>
              <div className={styles.toProduct}>
                <div className={styles.textBox}>
                  <Image
                    className={styles.logo}
                    src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-productdetail-logoslogan.svg"
                  />
                  <div className={styles.toProductLink}>
                    <a
                      target="_blank"
                      href="https://www.zhiyun-tech.com/cn/product/detail/835?type=website&page=homepage&source=first&title=%E6%99%BA%E4%BA%91%E4%BA%94%E5%80%8D%20V60"
                    >
                      <Text figmaStyle="header-3">了解更多</Text>
                    </a>

                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.05551 5.89562H3.16663V18.1178H15.3888V13.2289M9.27774 12.0067L17.2222 4.06228M12.9444 3.45117H17.8333V8.34006"
                        stroke="white"
                        stroke-width="1.33333"
                        stroke-linecap="square"
                      />
                    </svg>
                  </div>
                </div>
                <video
                  ref={videoRef}
                  muted
                  loop
                  // autoPlay
                  playsInline
                  preload="auto"
                  className={styles.tvc}
                  src="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiveray-v60/fiveray-v60-home.mp4"
                  poster="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-tvc-cover.jpg"
                ></video>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Work;
